import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useBreakpoints } from '@/hooks';

import * as S from './submit-confirmation.styles';

export const SubmitConfirmationHeader: React.VFC<{ copyKey: string }> = ({ copyKey }) => {
  const { isMobile } = useBreakpoints();

  return (
    <>
      <S.CheckImg size="large" />
      {isMobile ? (
        <S.MobileTitle size="xxlarge" forwardedAs="h1">
          <FormattedMessage id={copyKey} />
        </S.MobileTitle>
      ) : (
        <S.Title size="small">
          <FormattedMessage id={copyKey} />
        </S.Title>
      )}
    </>
  );
};
